import * as React from "react";
import { Text } from "./Text";
import { RAW_cssValue } from "../stylingLib";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var Pill = function Pill(_ref) {
  var size = _ref.size,
      children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "dt_white" : _ref$color,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "dt_kiwi50" : _ref$backgroundColor;
  // Default size
  var width = "26px";
  var fontSize = "14px";
  var padding = "2px 7px";
  var lineHeight = "22px";

  if (size === "m") {
    width = "36px";
    fontSize = "18px";
    padding = "4px 10px";
    lineHeight = "26px";
  }

  if (size === "l") {
    width = "42px";
    fontSize = "22px";
    padding = "4px 10px";
    lineHeight = "32px";
  }

  return _jsx("div", {
    sx: {
      display: "inline-block",
      minWidth: width,
      height: width,
      padding: RAW_cssValue(padding),
      borderRadius: RAW_cssValue(width),
      color: color,
      backgroundColor: backgroundColor
    },
    children: _jsx(Text, {
      nowrap: true,
      textAlign: "center",
      sx: {
        fontSize: fontSize,
        fontWeight: "bold",
        lineHeight: lineHeight
      },
      children: children
    })
  });
};
//# sourceMappingURL=Pill.js.map